import { isValueString } from '@/composables/helpers/useStringHelpers';

const filterOneSumsubItem = (routes) => {
  const firstSumsubItem = routes.findIndex(
    (route) => route.provider.toLowerCase() === 'sumsub',
  );

  const filteredRoutes = routes.filter(
    (route, index) => route.provider.toLowerCase() === 'banxa'
      || (route.provider.toLowerCase() === 'sumsub' && index === firstSumsubItem),
  );

  return filteredRoutes;
};

const organizeRoutes = (
  self,
  key,
  value,
  fromPath,
  identityRoutes,
  // exceptionRoutes,
  overrideRoutes,
) => {
  const banxaIdentityPages = Object.keys(identityRoutes.BANXA);
  const sumsubIdentityPages = Object.keys(identityRoutes.SUMSUB);

  const provider = value.toUpperCase();
  if (!isValueString(value)) {
    console.error('KYC Provider value is not returned');
    return;
  }

  if (!Object.getOwnPropertyDescriptor(identityRoutes, provider)) {
    console.error(`Wrong provider: ${provider} for identity`);
    return;
  }

  if (
    (provider === 'BANXA' && !banxaIdentityPages.includes(key))
    || (provider === 'SUMSUB' && !sumsubIdentityPages.includes(key))
  ) {
    console.error(`Identity: ${key} has no mapped route for send to`);
    return;
  }

  const { route: url, name } = identityRoutes[provider][key];

  // if identityRoutes has no previous key of route name
  // or sumsub recollection from /status has occured, to allow sumsub
  // based named routes to repopulate route array
  const noNewKeys = !self.identityRoutes.find(
    (route) => route?.name.toLowerCase() === name.toLowerCase()
      && route?.provider.toUpperCase() === provider.toUpperCase(),
  );

  // const isExceptionBased = exceptionRoutes.some(
  //   (routeName) => routeName === `${provider}.${key.toUpperCase()}`,
  // );

  // if (
  //   isExceptionBased
  //   && !self.identityRoutes.some(
  //     ({ provider: routeProvider, name: routeName }) => name === routeName && provider === routeProvider,
  //   )
  // ) {
  //   self.identityRoutes.push({ url, provider, name });
  // }

  if (
    // we skip adding new routes after personal_details as we can override the routes
    fromPath !== '/identity/identityConfirmation'
    && noNewKeys
    // || !isExceptionBased
  ) {
    self.identityRoutes.push({ url, provider, name });
    self.calculateTotalSteps();
  }
  overrideRoutes.push({ url, provider, name });
};

const sortRoutes = (routes) => {
  const filteredRoutes = filterOneSumsubItem(routes);

  // always be as a first item
  const billingDetailsIndex = filteredRoutes.findIndex(
    (doc) => doc.name === 'Billing Details',
  );

  if (billingDetailsIndex === -1) {
    return filteredRoutes;
  }

  filteredRoutes.splice(0, 0, routes[billingDetailsIndex]);
  filteredRoutes.splice(billingDetailsIndex + 1, 1);
  return filteredRoutes;
};

export default { organizeRoutes, sortRoutes, filterOneSumsubItem };
